<template>
    <div>
        <form @submit.prevent="on_submit" id="submit_form">
            <div class="row justify-content-center">
                <div class="col-12 my-2">
                        <div class="back-flex">
                            <div class="btn-width-100">
                                <router-link to="/wallets" class="btn btn-success my-2 btn-width-100">{{ $t('label.back') }}</router-link>
                            </div>
                        </div>
                        <div class="h5" v-text="$t('wallets.label.auto_settlement_settings')"></div>
                </div>

                <div class="col-12 my-2">
                    <div class="form-group form-check">
                        <label class="switch">
                            <input type="checkbox"
                                   id="setting_status"
                                   v-model="setting_status.value"
                            >
                            <span class="slider round"></span>
                        </label>
                        <label for="setting_status"
                               class="btn m-0 p-0 text-secondary form-check-label pr-4"
                        >
                            {{ $t('label.consider_auto_settlement_settings') }}
                        </label>
                    </div>
                </div>

                <div class="col-12 col-md-6 my-2">
                    <label for="password" v-text="$t('label.wallet_password')"></label>
                    <input class="form-control" type="password" id="password" name="password" v-model="password.value">
                </div>

                <div v-for="(item, index) in form_data" :key="index">
                    <div class="row border border-success m-2 px-2 pb-4">
                        <div class="col-12">
                            <div class="text-danger mr-auto"
                                 style="cursor: pointer; width: fit-content;"
                                 @click="deleteRow(index)"
                            >
                                <i class="fas fa-trash"></i>
                            </div>
                        </div>
                        <div class="col-12 col-md-6 mb-2">
                            <label :for="`transfers.${index}.percent`" v-text="$t('label.percent')"></label>
                            <input class="form-control"
                                   :id="`transfers.${index}.percent`"
                                   :name="`transfers.${index}.percent`"
                                   type="number"
                                   v-model="form_data[index].percent"
                            >
                        </div>

                        <div class="col-12 col-md-6 mb-2">
                            <label :for="`transfers.${index}.destination_number`" v-text="$t('label.destination_number')"></label>
                            <input class="form-control transfers_destination_number"
                                   :id="`transfers.${index}.destination_number`"
                                   :name="`transfers.${index}.destination_number`"
                                   type="text"
                                   :style="isValidIban(form_data[index].destination_number) ? '' : 'border-color: red !important;'"
                                   @keyup="checkIban(form_data[index].destination_number, index)"
                                   @change="checkIban(form_data[index].destination_number, index)"
                                   dir="ltr"
                                   v-model="form_data[index].destination_number"
                            >
                        </div>

                        <div class="col-12 col-md-6 my-2">
                            <label :for="`transfers.${index}.destination_name`" v-text="$t('label.destination_firstname')"></label>
                            <input class="form-control"
                                   :id="`transfers.${index}.destination_name`"
                                   :name="`transfers.${index}.destination_name`"
                                   type="text"
                                   v-model="form_data[index].destination_name"
                            >
                        </div>
                    </div>
                </div>

                <div class="col-12 mt-5 pt-5">
                    <div class="d-flex align-items-center justify-content-between">
                        <div class="d-flex align-items-center justify-content-between">
                            <button class="btn btn-primary mx-2"
                                    type="button"
                                    v-text="$t('label.add_new_record')"
                                    @click="addRow()"
                            >
                            </button>
                            <div class="d-inline-block mx-2">
                                <select id="new_shareholder"
                                        name="new_shareholder"
                                        v-model="new_shareholder"
                                        class="form-control"
                                >
                                    <option :value="null" selected disabled v-text="$t('label.add_new_shareholder')"></option>
                                    <option v-for="(shareholder, index) in shareholders"
                                            :key="index"
                                            :value="shareholder"
                                            v-text="shareholder.first_name + ' ' + shareholder.last_name"
                                    ></option>
                                </select>
                            </div>
                            <div v-if="new_shareholder !== null"
                                 class="d-inline-block mx-2"
                            >
                                <select id="new_account_number"
                                        name="new_account_number"
                                        v-model="new_account_number"
                                        class="form-control"
                                >
                                    <option :value="null" selected disabled v-text="$t('label.add_new_account_number')"></option>
                                    <option v-for="(account_number, index) in new_shareholder.account_numbers"
                                            :key="index"
                                            :value="account_number"
                                            v-text="account_number"
                                    ></option>
                                </select>
                            </div>
                        </div>
                        <div v-if="should_two_factor_settlement">
                            <button class="btn btn-success mr-auto"
                                    type="submit"
                                    id="submit_button"
                                    v-text="$t('btn.send_code')"
                            ></button>
                        </div>
                        <div v-else>
                            <button class="btn btn-success mr-auto"
                                    type="submit"
                                    id="submit_button"
                                    v-text="$t('btn.submit_changes')"
                            ></button>
                        </div>
                    </div>
                </div>
            </div>
        </form>
        <otp-modal
            :loading="form_meta_data.submit_btn_progress"
            :message="$t('label.input_verification_code')"
            :two_factor_type="form_data.two_factor_type"
            @sendRequest="sendRequest"
            @emitAction="setOtp"
        />
    </div>
</template>

<script>
    import {i18n} from "@/plugins/i18n";
    import {ibanInfo, walletShareHolderService} from "@/common/api.service";
    import Num2persian from 'num2persian';
    import Inputmask from 'inputmask';
    import IranSheba from "iran-sheba";
    import $ from 'jquery';
    import otpModal from "@/components/elements/modal/otp-modal.vue";
    import {TwoFactorType} from "@/constants/TwoFactorType";
    import Axios from "axios";

    export default {
        components: {otpModal},
        data() {
            return {
                Num2persian,
                shareholders: [],
                new_shareholder: null,
                new_account_number: null,
                last_iban_check: '',
                should_two_factor_settlement: false,
            };
        },
        watch: {
            new_account_number(value) {
                if (value === null) {
                    return;
                }

                // if last record is empty, fill it. otherwise add new record
                if (this.form_data[this.form_data.length - 1].destination_number === ''
                    && this.form_data[this.form_data.length - 1].destination_name === ''
                ) {
                    this.form_data[this.form_data.length - 1].destination_number = this.new_account_number;
                    this.form_data[this.form_data.length - 1].destination_name =
                        this.new_shareholder.first_name + ' ' + this.new_shareholder.last_name;
                } else {
                    this.form_data.push({
                        percent: 0,
                        destination_number: this.new_account_number,
                        destination_name: this.new_shareholder.first_name + ' ' + this.new_shareholder.last_name,
                    });
                }

                this.new_account_number = null;
                this.new_shareholder = null;
            },
            transfer_length() {
                setTimeout(() => {
                    this.initShebaMask();
                }, 500);
            },
        },
        computed: {
            transfer_length() {
                return this.form_data.length;
            },
        },
        props: {
            form_meta_data: {
                type: Object,
                default: () => {
                    return {
                        submit_btn_progress: false,
                        submit_btn_text: i18n.t('btn.submit'),
                    };
                },
            },
            on_submit: {
                type: Function,
                default: () => {},
            },
            form_data: Array,
            password: Object,
            setting_status: Object,
        },
        mounted() {
            walletShareHolderService.shareholderList().then(res => {
                this.shareholders = res.data.data;
            });
            Axios.get('wallet/common?wallet_prefix=A').then(response => {
                response.data.data.forEach(wallet => {
                    if (wallet.id === this.$route.params.hashid) {
                        this.should_two_factor_settlement = wallet.should_two_factor_settlement;
                        this.form_data.should_two_factor_settlement = wallet.should_two_factor_settlement;
                        this.$emit('updateShouldTwoFactor', wallet.should_two_factor_settlement);
                    }
                })
            });

            this.initShebaMask();
        },
        methods: {
            sendRequest(type) {
                this.form_data.two_factor_type = type;
                if (type === TwoFactorType.SMS) this.on_submit()
            },
            setOtp(data) {
              this.form_data.otp = data;
              this.$emit('settlement')
            },
            isValidIban(iban) {
                iban = iban.replace(/[\-_ ]/g, '');

                if (iban.length !== 26) { // 26 with IR
                    return false;
                }

                return IranSheba.isValid(iban);
            },
            checkIban(iban, index) {
                iban = iban.replace(/[\-_ ]/g, '');

                if (! this.isValidIban(iban)) {
                    return;
                }

                if (this.last_iban_check === iban) {
                    return;
                } else {
                    this.last_iban_check = iban;

                    setTimeout(() => {
                        this.last_iban_check = '';
                    }, 1000);
                }

                $('#submit_button').focus();

                let params = {
                    iban: iban,
                };

                let hashid = this.$route.params.hashid;

                ibanInfo.get(params, hashid).then(res => {
                    let data = res.data.data;
                    this.form_data[index].destination_name = data.first_name + ' ' + data.last_name;
                    this.$forceUpdate();
                });
            },
            deleteRow(index) {
                if (this.form_data.length < 2) {
                    return;
                }

                this.form_data.splice(index, 1);
            },
            addRow() {
                if (this.form_data.length > 100) {
                    return;
                }

                this.form_data.push({
                    percent: 0,
                    destination_number: '',
                    destination_firstname: '',
                    destination_lastname: '',
                });
            },
            initShebaMask() {
                Inputmask("IR 9999-9999-9999-9999-9999-9999").mask(document.querySelectorAll('.transfers_destination_number'));
            },
        }
    }
</script>

<style scoped>
    .filter_green {
        filter: invert(68%) sepia(25%) saturate(7218%) hue-rotate(130deg)
        brightness(91%) contrast(101%);
    }
    .back-flex {
        display: flex;
        flex-direction: row;
        align-items: flex-start;
        justify-content: flex-end;
    }
    a:hover.wage_wallet{
        color: gray;
    }
</style>
